import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

export default function SubMenuBar({ activeParent }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (!activeParent?.children) return null;

  // Recursive menu builder
  const buildMenuItems = (items = []) =>
    items.map((item) => {
      // If item has sub-children → SubMenu
      if (item.children && item.children.length > 0) {
        return {
          key: item.key || item.label,
          label: item.label,
          children: buildMenuItems(item.children),
        };
      }

      // Normal menu item
      return {
        key: item.to,
        label: item.label,
      };
    });

  const menuItems = buildMenuItems(activeParent.children);

  return (
    <div
      style={{
        position: "sticky",
        top: 87,
        zIndex: 99,
        background: "#fff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        paddingLeft:'70px'
      }}
    >
      <Menu
        mode="horizontal"
        items={menuItems}
        selectedKeys={[location.pathname]}
        onClick={({ key }) => navigate(key)}
        style={{
          paddingLeft: 24,
          padding: 5,
          fontSize: "15px",
          borderBottom: "1px solid #e5e7eb",
        }}
      />
    </div>
  );
}
